export default "__VITE_ASSET__52c33587__"